import { useState, type FormEvent } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { ApiError } from '../api/client'
import { useAuth, useRegister } from '../app/auth'
import { EmailVerifyForm } from './EmailVerifyForm'

// Öffentliche Werkstatt-Selbstregistrierung (Admin/Chef): legt Werkstatt + Chef an. E-Mail ist PFLICHT und muss
// danach per 6-stelligem Code bestätigt werden — erst DANN ist man eingeloggt.
export function WorkshopRegisterPage() {
  const { user, isLoading } = useAuth()
  const navigate = useNavigate()
  const register = useRegister()
  const [workshopName, setWorkshopName] = useState('')
  const [chefName, setChefName] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [avv, setAvv] = useState(false)
  // Nach der Registrierung: auf die Code-Eingabe umschalten (login = Benutzername, an den der Code-Verify geht).
  const [pending, setPending] = useState<{ login: string; email: string | null } | null>(null)

  if (!isLoading && user) return <Navigate to="/" replace />

  if (pending) {
    return <EmailVerifyForm login={pending.login} email={pending.email} onVerified={() => navigate('/', { replace: true })} />
  }

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    const uname = username
    register.mutate(
      {
        workshop_name: workshopName.trim(),
        chef_name: chefName.trim(),
        username: uname,
        password,
        email: email.trim() || undefined,
        avv_accepted: avv,
      },
      { onSuccess: (res) => setPending({ login: uname, email: res.email }) },
    )
  }

  const errorMessage = register.error instanceof ApiError ? register.error.message : register.isError ? 'Registrierung fehlgeschlagen' : null

  return (
    <div className="centered">
      <form className="card login" onSubmit={onSubmit}>
        <h1>Werkstatt registrieren</h1>
        <p className="hint">Lege deine Werkstatt und dein Chef-Konto an. Danach bist du direkt angemeldet.</p>
        <label className="field">
          <span>Werkstatt-Name</span>
          <input name="workshop_name" value={workshopName} onChange={(e) => setWorkshopName(e.target.value)} />
        </label>
        <label className="field">
          <span>Dein Name</span>
          <input name="chef_name" value={chefName} onChange={(e) => setChefName(e.target.value)} />
        </label>
        <label className="field">
          <span>Benutzername</span>
          <input
            name="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
          />
        </label>
        <label className="field">
          <span>Passwort (min. 8 Zeichen)</span>
          <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <label className="field">
          <span>E-Mail (Pflicht — wird per Code bestätigt)</span>
          <input name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="wf-checkfield">
          <input type="checkbox" checked={avv} onChange={(e) => setAvv(e.target.checked)} />
          <span>
            Ich akzeptiere die <Link to="/datenschutz">Datenschutzerklärung</Link> und den{' '}
            <Link to="/avv">Auftragsverarbeitungsvertrag (AVV)</Link>.
          </span>
        </label>
        {errorMessage && (
          <p className="error" role="alert">
            {errorMessage}
          </p>
        )}
        <button type="submit" className="btn" disabled={register.isPending}>
          {register.isPending ? 'Werkstatt wird angelegt…' : 'Werkstatt registrieren'}
        </button>
        <nav className="wf-legalfoot" aria-label="Navigation">
          <Link to="/login">Zurück zur Anmeldung</Link>
        </nav>
      </form>
    </div>
  )
}
